<template>
    <div class="flex flex-wrap mb-5">
        <div class="w-full">
            <h1 class="text-theme-primary">Felicitaciones 🎉 !</h1>
        </div>
        <div class="w-full mt-2">
            <p class="text-justify">
                Ya has aprendido a registrar inventario y ventas en tu tienda.
                Estamos muy felices que hagas parte de este proyecto y esperamos
                que con tu ayuda podamos seguir creciendo.
                <br />
                <br />
                Puedes explorar las demás funciones que tenemos disponibles,
                como la carga múltiple de inventario a través de un archivo
                Excel, el registro de servicios, la creación de productos nuevos
                que aún no estén registrados, y la opción de invitar a tus
                empleados a formar parte de la tienda.
            </p>
        </div>
        <div class="w-full flex justify-center mt-3">
            <app-button size="large" @click="$router.push('/app')">
                Explorar Funciones
            </app-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "OnboardingFinish",
    mounted() {
        this.$analytics.trackEvent("onboarding_completed", {
            onboarding_type: "marketplace"
        });
    }
};
</script>
